import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateDecimal',
})
export class TruncateDecimalPipe implements PipeTransform {
  transform(value: number, decimals: number = 1): number {
    const factor = Math.pow(10, decimals);
    return Math.floor(value * factor) / factor;
  }
}
